import React from 'react';

const ComponentPreview = ({ title, children }) => {
  return (
    <div className="mb-6 p-6 rounded-lg bg-card border border-border">
      {title && (
        <h4 className="text-base font-medium text-foreground mb-4">{title}</h4>
      )}
      <div className="p-6 rounded-md bg-muted/30">
        {children}
      </div>
    </div>
  );
};

export default ComponentPreview;